import { Flex } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { getDevice } from "src/modules/auth/duck/selectors";
import { getPairedDevice } from "src/modules/device/duck/selectors";
import { Activities } from "src/modules/activity-log/activity";
import environment from "src/utils/environment";
import SvgContainer from "src/components/SvgContainer";
import { Overline } from "src/atoms/typography";
import { deviceColors } from "../../device-spec";
import { ReactComponent as DesktopIcon } from "./notebook-small.svg";
import { ReactComponent as PhoneIcon } from "./phone-small.svg";
import { ReactComponent as TabletIcon } from "./tablet-small.svg";

function getIcon(jid) {
  if (!jid) return PhoneIcon;
  if (jid.endsWith("9") || jid.endsWith("4")) {
    return DesktopIcon;
  }
  if (jid.endsWith("3") || jid.endsWith("6")) {
    return TabletIcon;
  }
  return PhoneIcon;
}

function useDevice(jid) {
  const thisDevice = useSelector(getDevice);
  const pairedDevice = useSelector((state) => getPairedDevice(state, jid));
  const device = pairedDevice || thisDevice;

  const deviceColor = deviceColors[device?.color] || deviceColors.other;
  return { device, deviceColor };
}

export function DeviceIcon({ deviceJid, size = "20px" }) {
  const { deviceColor } = useDevice(deviceJid);

  return (
    <Flex
      bg={deviceColor.secondary}
      justifyContent="center"
      alignItems="center"
      p="6px"
      borderRadius="100%"
    >
      <SvgContainer
        size={size}
        icon={getIcon(deviceJid)}
        fill={deviceColor.primary}
      />
    </Flex>
  );
}

export function DeviceTabMark({ deviceJid, mark }) {
  const { deviceColor } = useDevice(deviceJid);

  return (
    <Flex
      justifyContent="center"
      bg={deviceColor.primary}
      width="14px"
      height="14px"
      borderRadius="100%"
      position="absolute"
      transform="translate(25%, -15%)"
      top="0px"
      right="0px"
      color="white"
      fontSize="10px"
      fontWeight="bold"
      zIndex={10}
    >
      {mark || "A"}
    </Flex>
  );
}

export function DeviceName({ deviceJid, activity = "none" }) {
  const { isBibino } = environment;
  const { deviceColor, device } = useDevice(deviceJid);

  let color = deviceColor.primary;
  if (
    activity === Activities.AWAKE ||
    (activity === Activities.MOTION && isBibino)
  ) {
    color = "white";
  }

  return (
    <Flex mt="8px" alignItems="center" justifyContent="center">
      <Overline color={color}>{device?.name?.toUpperCase()}</Overline>
    </Flex>
  );
}
